import { Button } from "@material-ui/core";
import { useI18n } from "../../hooks/useI18n";

const AccessDenied = () => {
  const { t } = useI18n();
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>{t("common.messages.accessDenied")}</h1>
      <p>{t("common.messages.noPermissionToViewPage")}</p>

      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          window.location.href = "/auth/logout";
        }}
      >
        {t("common.actions.logout")}
      </Button>
    </div>
  );
};

export default AccessDenied;
